import React from "react";
import "./Template_1.css";

const Template_1_Reviews = () => {
  const reviews = [
    {
      text: "The Maldives package was absolutely incredible. The resort was even better than pictured, and the staff went above and beyond to make our stay memorable. Will definitely book with TravelEase again!",
      author: "Sarah Johnson",
      role: "Maldives Traveler",
      image: "https://randomuser.me/api/portraits/women/65.jpg",
      rating: 5,
    },
    {
      text: "Our family trip to Bali was perfectly organized. The activities were engaging for both kids and adults, and the guides were knowledgeable and friendly. Thanks for the wonderful memories!",
      author: "Michael Chen",
      role: "Family Traveler",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      rating: 5,
    },
    {
      text: "The pilgrimage tour to Varanasi was a spiritually enriching experience. The accommodations were comfortable, and the itinerary perfectly balanced sightseeing with spiritual activities. Highly recommended!",
      author: "Priya Sharma",
      role: "Pilgrimage Traveler",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      rating: 4.5,
    },
  ];

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star"></i>);
    }

    if (hasHalfStar) {
      stars.push(<i key="half" className="fas fa-star-half-alt"></i>);
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={`empty-${i}`} className="far fa-star"></i>);
    }

    return stars;
  };

  return (
    <section id="reviews" className="Template_1 section Template_1 reviews">
      <div className="Template_1 container">
        <div className="Template_1 section-title">
          <h2>Customer Reviews</h2>
          <p>See what our travelers have to say about their experiences</p>
        </div>
        <div className="Template_1 reviews-grid">
          {reviews.map((review, index) => (
            <div key={index} className="Template_1 review-card">
              <div className="Template_1 review-text">
                <p>{review.text}</p>
              </div>
              <div className="Template_1 review-author">
                <img src={review.image} alt={review.author} />
                <div>
                  <h4>{review.author}</h4>
                  <p>{review.role}</p>
                  <div className="Template_1 review-rating">
                    {renderStars(review.rating)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Template_1_Reviews;
